import { HttpClient } from '@angular/common/http';
import { Component,  OnInit, Input } from '@angular/core';
import { LoadingMaskService } from './LoadingMaskService';

@Component({
    selector: 'loading-mask',
    templateUrl: './loading-mask.component.html',
    standalone: false
})

export class LoadingMaskComponent implements OnInit {
  @Input() workflowCode: string = null;
  public loader:boolean = false;
  public loadingWorkflow: boolean = false;
  public isContagemTempo: boolean = false;
  public loadingPM: boolean = false;
    constructor(loadingMaskService : LoadingMaskService) {
        loadingMaskService.loadingChangedSubject.subscribe(result => {
          this.setLoading(result[0], result[1], result[2], result[3]);
        })
    }

  public setLoading(showLoading: boolean, loadWorkflow?: boolean, isCT?: boolean, loadPM?: boolean) {
    this.loader = showLoading;
    if (loadWorkflow !== undefined) {
      this.loadingWorkflow = loadWorkflow;
    }
    if (loadPM !== undefined) {
      this.loadingPM = loadPM;
    }
    if (this.loadingPM) {
      this.loadingWorkflow = false;
    }
    if (isCT !== undefined && isCT !== null) {
      this.isContagemTempo = isCT;
    } else {
      if (isCT === null) {
        this.isContagemTempo = null;
      }
    }
      

    }

    ngOnInit(): void {
    }
}
